export const ICONS = {
  cactus: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#248A3D' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🌵 Cactus Icon -->
    <ellipse cx='12' cy='21.5' rx='7' ry='1.5' fill='#DFB784' stroke='#C69C6D' stroke-width='1'/>
    <rect x='10' y='3' width='4' height='18' rx='2' fill='#34C759' stroke='#248A3D' stroke-width='1.5'/>
    <line x1='12' y1='5' x2='12' y2='19' stroke='#248A3D' stroke-width='1' stroke-dasharray='1 1.5'/>
    <path d='M10 13H7a2 2 0 0 1-2-2V7a2 2 0 0 1 4 0v3h1' fill='#34C759' stroke='#248A3D' stroke-width='1.5' stroke-linejoin='round'/>
    <line x1='7' y1='7' x2='7' y2='12' stroke='#248A3D' stroke-width='1' stroke-dasharray='1 1.5'/>
    <path d='M14 15h3a2 2 0 0 0 2-2V9a2 2 0 0 0-4 0v3h-1' fill='#34C759' stroke='#248A3D' stroke-width='1.5' stroke-linejoin='round'/>
    <line x1='17' y1='9' x2='17' y2='14' stroke='#248A3D' stroke-width='1' stroke-dasharray='1 1.5'/>
  </svg>`,
  home: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#248A3D' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🌵 Cactus Icon -->
    <ellipse cx='12' cy='21.5' rx='7' ry='1.5' fill='#DFB784' stroke='#C69C6D' stroke-width='1'/>
    <rect x='10' y='3' width='4' height='18' rx='2' fill='#34C759' stroke='#248A3D' stroke-width='1.5'/>
    <line x1='12' y1='5' x2='12' y2='19' stroke='#248A3D' stroke-width='1' stroke-dasharray='1 1.5'/>
    <path d='M10 13H7a2 2 0 0 1-2-2V7a2 2 0 0 1 4 0v3h1' fill='#34C759' stroke='#248A3D' stroke-width='1.5' stroke-linejoin='round'/>
    <line x1='7' y1='7' x2='7' y2='12' stroke='#248A3D' stroke-width='1' stroke-dasharray='1 1.5'/>
    <path d='M14 15h3a2 2 0 0 0 2-2V9a2 2 0 0 0-4 0v3h-1' fill='#34C759' stroke='#248A3D' stroke-width='1.5' stroke-linejoin='round'/>
    <line x1='17' y1='9' x2='17' y2='14' stroke='#248A3D' stroke-width='1' stroke-dasharray='1 1.5'/>
  </svg>`,

  sun: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#FF9500' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🌞 Sun: Golden yellow glow -->
    <circle cx='12' cy='12' r='4' fill='#FFCC00' stroke='#FF9500'/>
    <path d='M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41'/>
  </svg>`,

  waves: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#5AC8FA' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🌊 Waves: Ocean teal/blue -->
    <path d='M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1' stroke='#007AFF'/>
    <path d='M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1' stroke='#5AC8FA'/>
    <path d='M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1' stroke='#007AFF'/>
  </svg>`,

  disc: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🪩 Disco Ball / Vinyl: Silver metallic with blue-grey highlights -->
    <circle cx='12' cy='12' r='10' fill='#E5E5EA' stroke='#8E8E93'/>
    <path d='M12 12m-3 0a3 3 0 1 0 6 0 3 3 0 1 0-6 0' fill='#5AC8FA' stroke='#007AFF'/>
    <path d='M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z' stroke='#AEAEB2'/>
    <path d='M2 12h20' stroke='#AEAEB2'/>
  </svg>`,

  calendar: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 📆 Calendar: Red top section with white page -->
    <rect width='18' height='18' x='3' y='4' rx='2' ry='2' fill='#FFFFFF' stroke='#8E8E93'/>
    <path d='M3 4h18v6H3V4z' fill='#FF3B30' stroke='#FF3B30'/>
    <line x1='16' x2='16' y1='2' y2='6' stroke='#8E8E93'/>
    <line x1='8' x2='8' y1='2' y2='6' stroke='#8E8E93'/>
    <path d='M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01' stroke='#3A3A3C' stroke-width='2'/>
  </svg>`,

  headphones: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#3A3A3C' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🎧 Headphones: Glossy dark grey with bright blue pads -->
    <path d='M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3' fill='none'/>
    <rect x='2' y='13' width='4' height='6' rx='1' fill='#007AFF' stroke='#007AFF'/>
    <rect x='18' y='13' width='4' height='6' rx='1' fill='#007AFF' stroke='#007AFF'/>
  </svg>`,

  moon: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#FF9500' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🌛 Moon: Yellow gold crescent -->
    <path d='M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z' fill='#FFCC00'/>
  </svg>`,

  map: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🗺 Map: Blue water background, green fold sections -->
    <polygon points='3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21' fill='#5AC8FA'/>
    <path d='M9 3v15M15 6v15' stroke='#8E8E93'/>
    <rect x='4' y='7' width='3' height='4' rx='1' fill='#34C759' stroke='#34C759'/>
    <rect x='10' y='11' width='4' height='5' rx='1' fill='#34C759' stroke='#34C759'/>
    <rect x='16' y='5' width='3' height='4' rx='1' fill='#34C759' stroke='#34C759'/>
  </svg>`,

  building: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🏙 Building: Dark grey structure with yellow glowing windows -->
    <path d='M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z' fill='#3A3A3C' stroke='#8E8E93'/>
    <path d='M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2' fill='#48484A' stroke='#8E8E93'/>
    <path d='M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2' fill='#48484A' stroke='#8E8E93'/>
    <!-- Windows -->
    <path d='M10 6h4M10 10h4M10 14h4M10 18h4' stroke='#FFCC00' stroke-width='2'/>
  </svg>`,

  leaf: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#34C759' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🌿 Leaf: Vibrant organic green -->
    <path d='M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z' fill='#34C759'/>
    <path d='M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12' stroke='#34C759'/>
  </svg>`,

  palmtree: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#A2845E' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🌴 Palm tree: Brown trunk with green canopy -->
    <path d='M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4' fill='#34C759' stroke='#34C759'/>
    <path d='M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3' fill='#34C759' stroke='#34C759'/>
    <path d='M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35z' fill='#34C759' stroke='#34C759'/>
    <path d='M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14' fill='none' stroke='#A2845E'/>
  </svg>`,

  palmtree2: `<svg xmlns='http://www.w3.org/2000/svg' width='50' height='50' viewBox='0 0 24 24' fill='none' stroke='#A2845E' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🌴 Beach Palm: Brown trunk, green leaves, blue waves -->
    <path d='M2 20c2-1 4-1 6 0s4 1 6 0 4-1 6 0' stroke='#5AC8FA'/>
    <path d='M4 22c3-.8 6-.8 9 0' stroke='#007AFF'/>
    <path d='M12 20c.8-3 .5-7-1.5-10.5' stroke='#A2845E'/>
    <path d='M10.5 9.5c-2.5.5-4.5-.5-5.5-2.5c2 1 4 2 5.5 2.5z' fill='#34C759' stroke='#34C759'/>
    <path d='M10.5 9.5c-1.5-2.5-3.5-3-5.5-2c2.5 0 4.5.5 5.5 2z' fill='#34C759' stroke='#34C759'/>
    <path d='M10.5 9.5c.5-2.5.5-4.5-1-6c1.5 2 1.5 4.5 1 6z' fill='#34C759' stroke='#34C759'/>
    <path d='M10.5 9.5c2.5-1.5 4-1 5.5 1c-2-1.5-4.5-1.5-5.5-1z' fill='#34C759' stroke='#34C759'/>
    <path d='M10.5 9.5c1 2.5.5 4.5-1.5 5.5c1.5-2 1.5-4.5 1.5-5.5z' fill='#34C759' stroke='#34C759'/>
  </svg>`,

  crown: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF9500" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <!-- 👑 Crown: Gold crown with glowing accent fill -->
    <path d="m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14" fill='#FFCC00'/>
  </svg>`,

  volume2: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <!-- 🔊 Speaker: Grey speaker with blue sound waves -->
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill='#8E8E93'/>
    <path d="M15.54 8.46a5 5 0 0 1 0 7.07" stroke='#5AC8FA'/>
    <path d="M19.07 4.93a10 10 0 0 1 0 14.14" stroke='#007AFF'/>
  </svg>`,

  ticket: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF9500" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <!-- 🎫 Ticket: Golden admission ticket -->
    <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" fill='#FFCC00'/>
    <path d="M13 5v2M13 17v2M13 11v2"/>
  </svg>`,

  mapPin: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke='#FF3B30' stroke-width="1.75" stroke-linecap='round' stroke-linejoin='round'>
    <!-- 📍 Map Pin: Apple red pin -->
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" fill='#FF3B30' fill-opacity='0.15'/>
    <circle cx="12" cy="10" r="3" fill='#FFFFFF'/>
  </svg>`,

  chevronDown: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="1.75" stroke-linecap='round' stroke-linejoin='round'>
    <path d="m6 9 6 6 6-6"/>
  </svg>`,

  messageSquare: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#34C759" stroke-width="1.75" stroke-linecap='round' stroke-linejoin='round'><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" fill='#34C759' fill-opacity='0.1'/></svg>`,
  arrowRight: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>`,
  rocketTree: `<svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <!-- 🌊 Waves: Ocean light blue -->
    <path d="M2 21c2-0.5 4-0.5 6 0s4 0.5 6 0 4-0.5 6 0" stroke="#5AC8FA" stroke-width="2"/>
    <!-- 🌴 Palm rocket central trunk: brown / metallic silver -->
    <path d="M12 3C12 3 9 7 9 13C9 16 10 18 12 19C14 18 15 16 15 13C15 7 12 3 12 3Z" fill="#E5E5EA" stroke="#8E8E93" stroke-width="1.5"/>
    <!-- Window: Blue -->
    <circle cx="12" cy="10" r="1.5" fill="#5AC8FA" stroke="#007AFF"/>
    <!-- Fins as Palm Leaves: Green -->
    <path d="M9 16C6 17 5 19 5 21C8 21 9 19 9 16Z" fill="#34C759" stroke="#34C759"/>
    <path d="M15 16C18 17 19 19 19 21C16 21 15 19 15 16Z" fill="#34C759" stroke="#34C759"/>
    <!-- Palm Leaves on top of rocket: Green -->
    <path d="M12 4C9 3 7 4 6 6C8 6 10 5 12 4Z" fill="#30D158" stroke="#30D158"/>
    <path d="M12 4C15 3 17 4 18 6C16 6 14 5 12 4Z" fill="#30D158" stroke="#30D158"/>
    <path d="M12 3C12 1 11 0 9 0C10 2 11 3 12 3Z" fill="#34C759" stroke="#34C759"/>
    <path d="M12 3C12 1 13 0 15 0C14 2 13 3 12 3Z" fill="#34C759" stroke="#34C759"/>
    <!-- Fire Plume: Red & Orange -->
    <path d="M12 19C11 20.5 10 22 10 23C11 23 12 22 12 20.5C12 22 13 23 14 23C14 22 13 20.5 12 19Z" fill="#FF9500" stroke="#FF3B30" stroke-width="1.5"/>
  </svg>`,
  sportShoes: `<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <!-- Sole: White -->
    <path d="M2 19c6 0 14 0 20 0c0-1.5-1-2.5-3-3H5c-2 .5-3 1.5-3 3Z" fill="#FFFFFF" stroke="#8E8E93"/>
    <!-- Body: Neon Blue -->
    <path d="M3 16V9.5C3 8 4.5 7 6 7c3 0 4 3.5 6 3.5s3.5-3 6-3c2 0 4 1.5 4 4.5v4" fill="#5AC8FA" stroke="#007AFF"/>
    <!-- Laces: Orange -->
    <path d="M8 8.5h3.5M9 11h2.5M9.5 13.5h2.5" stroke="#FF9500" stroke-width="2"/>
  </svg>`,
  cherry: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#34C759" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <!-- Cherries: Apple Red with glossy overlay -->
    <circle cx="7" cy="17" r="5" fill="#FF3B30" stroke="#FF3B30"/>
    <circle cx="17" cy="17" r="5" fill="#FF3B30" stroke="#FF3B30"/>
    <!-- Glossy reflection highlights -->
    <circle cx="5" cy="15" r="1.2" fill="#FFFFFF" stroke="none"/>
    <circle cx="15" cy="15" r="1.2" fill="#FFFFFF" stroke="none"/>
    <!-- Stems: Green -->
    <path d="M17 17c-2-3-5-8-12-8" stroke="#34C759"/>
    <path d="M7 17c1.5-1.5 4-5 5-8" stroke="#34C759"/>
    <path d="M5 9c0-2 1.5-4 4-4" fill="#30D158" stroke="#34C759"/>
  </svg>`,
  flame: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF3B30" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <!-- Outer Flame: Orange-Red -->
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" fill="#FF9500" stroke="#FF3B30"/>
    <!-- Inner Flame: Yellow core -->
    <path d="M12 18.5a4 4 0 0 0 4-4c0-1-.5-2-1-2.5a3.5 3.5 0 0 0-3 6.5z" fill="#FFCC00" stroke="none"/>
  </svg>`,

  link: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🔗 Link: Silver metallic loops -->
    <path d='M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71' fill='#8E8E93' fill-opacity='0.1'/>
    <path d='M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71' fill='#8E8E93' fill-opacity='0.1'/>
  </svg>`,

  email: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- ✉️ Envelope: White pocket with blue line fold -->
    <rect x='2' y='4' width='20' height='16' rx='2' fill='#FFFFFF' stroke='#8E8E93'/>
    <path d='m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7' stroke='#007AFF'/>
  </svg>`,

  toolbox: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🧰 Toolbox: Red metal chest with silver latches and handle -->
    <path d='M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2' stroke='#8E8E93'/>
    <path d='M16 6a2 2 0 0 1 1.414.586l4 4A2 2 0 0 1 22 12v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 .586-1.414l4-4A2 2 0 0 1 8 6z' fill='#FF3B30' stroke='#FF3B30'/>
    <path d='M2 14h20' stroke='#FFFFFF' stroke-width='1.5'/>
    <path d='M8 12v4' stroke='#E5E5EA' stroke-width='2'/>
    <path d='M16 12v4' stroke='#E5E5EA' stroke-width='2'/>
  </svg>`,

  lockKeyhole: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#FF9500' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🔒 Padlock: Golden brass body with metal shackle -->
    <path d='M7 10V7a5 5 0 0 1 10 0v3' stroke='#8E8E93'/>
    <rect x='3' y='10' width='18' height='12' rx='2' fill='#FFCC00' stroke='#FF9500'/>
    <circle cx='12' cy='16' r='1.2' fill='#3A3A3C' stroke='#3A3A3C' stroke-width='1'/>
  </svg>`,

  watch: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- ⌚ Watch: Dark strap, steel face and red hands -->
    <path d='m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05' fill='#3A3A3C' stroke='#3A3A3C'/>
    <path d='m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05' fill='#3A3A3C' stroke='#3A3A3C'/>
    <circle cx='12' cy='12' r='6' fill='#FFFFFF' stroke='#8E8E93'/>
    <path d='M12 10v2.2l1.6 1' stroke='#FF3B30' stroke-width='1.5'/>
  </svg>`,

  clock: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🕒 Clock: Silver rim with white face -->
    <circle cx='12' cy='12' r='10' fill='#FFFFFF' stroke='#8E8E93'/>
    <path d='M12 6v6l4 2' stroke='#3A3A3C' stroke-width='1.75'/>
  </svg>`,

  satellite: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🛰️ Satellite: Gold core with blue solar wings -->
    <path d='M9 21a6 6 0 0 0-6-6' stroke='#5AC8FA'/>
    <path d='M16.5 7.5 19 5' stroke='#8E8E93'/>
    <path d='m13.5 6.5-3.148-3.148a1.205 1.205 0 0 0-1.704 0L6.352 5.648a1.205 1.205 0 0 0 0 1.704L9.5 10.5' fill='#5AC8FA' stroke='#007AFF'/>
    <path d='m17.5 10.5 3.148 3.148a1.205 1.205 0 0 1 0 1.704l-2.296 2.296a1.205 1.205 0 0 1-1.704 0L13.5 14.5' fill='#5AC8FA' stroke='#007AFF'/>
    <path d='M9.352 10.648a1.205 1.205 0 0 0 0 1.704l2.296 2.296a1.205 1.205 0 0 0 1.704 0l4.296-4.296a1.205 1.205 0 0 0 0-1.704l-2.296-2.296a1.205 1.205 0 0 0-1.704 0z' fill='#FFCC00' stroke='#FF9500'/>
  </svg>`,

  mask: `<svg xmlns='http://www.w3.org/2000/svg' width='60' height='60' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🤿 Snorkel Mask: Teal mask with orange tube -->
    <path d='M4 11H2m18 0h-2' stroke='#8E8E93' stroke-width='1.5'/>
    <path d='M5 9c0-1.5 1-2.5 3-2.5h6c2 0 3 1 3 2.5v3c0 1.5-1 2.5-3 2.5H8c-2 0-3-1-3-2.5V9z' fill='#5AC8FA' fill-opacity='0.2' stroke='#3A3A3C' stroke-width='2'/>
    <path d='M10 11.5a2 2 0 0 0 4 0v-1' stroke='#3A3A3C' stroke-dasharray='1 1'/>
    <path d='M16 11.5c.5.5 1 1 2 1s1.5-.5 1.5-1.5v-7.5' fill='none' stroke='#FF9500' stroke-width='2.2'/>
    <path d='M19.5 3.5h-1v-1h1v1z' fill='#FF3B30' stroke='none'/>
    <path d='M16.5 12h-1' stroke='#FF9500' stroke-width='1.5'/>
  </svg>`,

  sunrise: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#FF9500' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🌅 Sunrise: Sun rising over ocean waves -->
    <path d='M2 18h20' stroke='#5AC8FA' stroke-width='2'/>
    <path d='M17 18a5 5 0 0 0-10 0' fill='#FFCC00' stroke='#FF9500'/>
    <path d='M12 2v4M4.93 10.93l2.83 2.83M19.07 10.93l-2.83 2.83' stroke='#FF9500'/>
  </svg>`,

  fileText: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#007AFF' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 📄 File: Silver page with blue text lines -->
    <path d='M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z' fill='#FFFFFF' stroke='#8E8E93'/>
    <polyline points='14 2 14 8 20 8' fill='#E5E5EA' stroke='#8E8E93'/>
    <line x1='16' y1='13' x2='8' y2='13' stroke='#007AFF' stroke-width='1.5'/>
    <line x1='16' y1='17' x2='8' y2='17' stroke='#007AFF' stroke-width='1.5'/>
    <line x1='10' y1='9' x2='8' y2='9' stroke='#007AFF' stroke-width='1.5'/>
  </svg>`,

  mexico: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
    <!-- 🇲🇽 Mexico Flag: Green, White, and Red stripes with Golden Cactus emblem -->
    <rect x="3" y="4" width="18" height="16" rx="2" ry="2" fill="#FFFFFF" stroke="#8E8E93" stroke-width="1.5" />
    <path d="M3.5 4.5h5.5v15H3.5z" fill="#34C759" stroke="none" />
    <path d="M15 4.5h5.5v15H15z" fill="#FF3B30" stroke="none" />
    <circle cx="12" cy="12" r="2.5" fill="#FFCC00" stroke="#A2845E" stroke-width="1" />
    <path d="M11 13.5l1-1.5 1 1.5" stroke="#34C759" stroke-width="1" fill="none" />
  </svg>`,

  circle: `<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'>
    <!-- ⚪ White Circle: Silver rim with soft white center -->
    <circle cx='12' cy='12' r='10' fill='#F2F2F7' stroke='#AEAEB2'/>
  </svg>`,

  party: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#FF9500' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🎉 Party Popper: Yellow/Gold cone with red/green/blue confetti spark streams -->
    <path d='M2 22l8-8c1-1 3-1 4 0l6 6c1 1 1 3 0 4l-8-8c-1-1-3-1-4 0z' fill='#FFCC00' stroke='#FF9500'/>
    <!-- Confetti Sparks -->
    <circle cx='16' cy='8' r='1.5' fill='#FF3B30' stroke='none'/>
    <circle cx='8' cy='4' r='1.5' fill='#34C759' stroke='none'/>
    <circle cx='12' cy='6' r='2' fill='#5AC8FA' stroke='none'/>
    <path d='m12 2 1 2-2 1M18 10l2-1-1-2' stroke='#FF9500' stroke-width='1'/>
  </svg>`,

  phone: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 📲 Smartphone: Green screen, silver phone chassis -->
    <rect x='5' y='2' width='14' height='20' rx='2' ry='2' fill='#E5E5EA' stroke='#8E8E93'/>
    <rect x='6' y='5' width='12' height='14' rx='1' fill='#34C759' fill-opacity='0.15' stroke='#34C759' stroke-width='1.2'/>
    <circle cx='12' cy='20' r='1' fill='#3A3A3C' stroke='none'/>
  </svg>`,

  help: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- ❓ Question Circle: Blue/teal circular badge with question mark -->
    <circle cx='12' cy='12' r='10' fill='#5AC8FA' fill-opacity='0.15' stroke='#5AC8FA'/>
    <path d='M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3' stroke='#007AFF' stroke-width='2'/>
    <line x1='12' y1='17' x2='12.01' y2='17' stroke='#007AFF' stroke-width='3' stroke-linecap='round'/>
  </svg>`,

  beach: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#FF9500' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🏖️ Beach Parasol: Yellow & Red umbrella in golden sand -->
    <path d='M2 20c4-1 8-1 12 0s8 1 12 0' stroke='#A2845E' stroke-width='2'/>
    <line x1='12' y1='20' x2='12' y2='8' stroke='#8E8E93' stroke-width='2'/>
    <path d='M12 8C8 8 5 11 5 13h14c0-2-3-5-7-5z' fill='#FF3B30' stroke='#FF3B30'/>
    <path d='M12 8c-2 0-3.5 2-3.5 5h7c0-3-1.5-5-3.5-5z' fill='#FFCC00' stroke='#FF9500'/>
  </svg>`,

  money: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#34C759' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 💵 Banknotes: Minimalist cash notes symbol -->
    <rect width='20' height='12' x='2' y='6' rx='2' fill='#34C759' fill-opacity='0.15' stroke='#34C759'/>
    <circle cx='12' cy='12' r='2.5' fill='#34C759' fill-opacity='0.2' stroke='#34C759'/>
    <path d='M8 12h.01M16 12h.01' stroke='#34C759' stroke-width='2'/>
  </svg>`,

  rocket: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#FF9500' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🚀 Rocket: Red nose, white body, yellow fins and fire engine -->
    <path d='M4.5 16.5c-1.5 1.5-2.5 3.5-2.5 5.5 2-2 4-3 5.5-4.5' stroke='#FF3B30' stroke-width='2'/>
    <path d='M12 2C9 5 9 9 9 9s-4 0-7 3l1 5 3 1 5-1c3-3 3-7 3-7s-4 0-7-3z' fill='#F2F2F7' stroke='#AEAEB2'/>
    <path d='M9 15l-3.5 3.5-2-2.5L7 12.5z' fill='#FF9500' stroke='#FF9500' stroke-width='1'/>
    <path d='M19 5c1-1 3-3 3-3s-2 2-3 3z' fill='#FF3B30' stroke='#FF3B30'/>
    <circle cx='14' cy='10' r='2.5' fill='#5AC8FA' stroke='#007AFF' stroke-width='1.2'/>
  </svg>`,

  ufo: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#5AC8FA' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🛸 UFO: Glass dome with alien silhouette, glowing saucer, and tractor beam -->
    <path d='M7 16l-3 6h16l-3-6H7z' fill='#34C759' fill-opacity='0.15' stroke='#34C759' stroke-dasharray='2 2' stroke-width='1'/>
    <path d='M8 12c0-3.5 2-5 4-5s4 1.5 4 5' fill='#5AC8FA' fill-opacity='0.25' stroke='#5AC8FA' stroke-width='1.75'/>
    <ellipse cx='12' cy='10' rx='1.5' ry='2' fill='#34C759' stroke='none'/>
    <path d='M3 13c0-1.5 4-3 9-3s9 1.5 9 3-4 3-9 3-9-1.5-9-3z' fill='#E5E5EA' stroke='#8E8E93' stroke-width='1.5'/>
    <circle cx='6' cy='13' r='0.75' fill='#FFCC00' stroke='none'/>
    <circle cx='9' cy='13.5' r='0.75' fill='#FF3B30' stroke='none'/>
    <circle cx='12' cy='14' r='0.75' fill='#5AC8FA' stroke='none'/>
    <circle cx='15' cy='13.5' r='0.75' fill='#FF9500' stroke='none'/>
    <circle cx='18' cy='13' r='0.75' fill='#FFCC00' stroke='none'/>
  </svg>`,

  utensils: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 🍽️ Fork & Knife / Dinner -->
    <path d='M18 2v20M18 2a4 4 0 0 1 4 4v4h-4' fill='#5AC8FA' fill-opacity='0.2' stroke='#8E8E93'/>
    <path d='M6 2v20M3 2v6a3 3 0 0 0 6 0V2' stroke='#8E8E93'/>
  </svg>`,

  astronaut: `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#8E8E93' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'>
    <!-- 👩‍🚀 Astronaut / Concierge Helmet -->
    <circle cx='12' cy='12' r='8' fill='#F2F2F7' stroke='#8E8E93'/>
    <ellipse cx='12' cy='11' rx='5' ry='3.5' fill='#FFCC00' stroke='#FF9500'/>
    <path d='M6 20a6 6 0 0 1 12 0' stroke='#5AC8FA' stroke-width='2'/>
  </svg>`,
};
